import dayjs from "dayjs";

export const formatDate = (dateString: string) =>
  dayjs(dateString).format("MM/DD/YY");
export const formatDateTime = (dateString: string) =>
  dayjs(dateString).format("MM/DD/YY, h:mm A");
